import { render } from "./HSTableSkeleton.vue?vue&type=template&id=10aa79ec&scoped=true"
import script from "./HSTableSkeleton.vue?vue&type=script&lang=js"
export * from "./HSTableSkeleton.vue?vue&type=script&lang=js"

import "./HSTableSkeleton.vue?vue&type=style&index=0&id=10aa79ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10aa79ec"]])

export default __exports__